import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import BorrowerHeader from "../../../Header/BorrowerHeader";
import BorrowerSidebar from "../../../SideBar/BorrowerSidebar";
import { registerMarketplaceEnach } from "../../../HttpRequest/afterlogin";

const MarketplaceEnach = () => {
  const { loanRequestId } = useParams();
  const navigate = useNavigate();

  const [step, setStep] = useState("form"); // form | confirm | otp | success
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    accountHolder: "",
    accountNumber: "",
    confirmAccount: "",
    ifsc: "",
    bankName: "",
    accountType: "SAVINGS",
    debitDay: "5",
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (form.accountNumber !== form.confirmAccount) {
      setError("Account numbers do not match.");
      return;
    }
    if (!form.ifsc || form.ifsc.length < 11) {
      setError("Please enter a valid 11-character IFSC code.");
      return;
    }
    setStep("confirm");
  };

  const sendOtp = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStep("otp");
    }, 700);
  };

  const verifyOtp = () => {
    setLoading(true);
    setError("");
    registerMarketplaceEnach({
      loanRequestId,
      accountHolder: form.accountHolder,
      accountNumber: form.accountNumber,
      ifsc: form.ifsc,
      bankName: form.bankName,
      accountType: form.accountType,
      debitDay: Number(form.debitDay),
      otp,
    })
      .then(() => {
        setStep("success");
        setLoading(false);
      })
      .catch((err) => {
        setError(err?.response?.data?.message || "OTP verification failed. Please try again.");
        setLoading(false);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <BorrowerHeader />
        <BorrowerSidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">eNACH / Auto-Debit Setup</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/borrowerDashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/my-marketplace-loans">My Loans</Link>
                    </li>
                    <li className="breadcrumb-item active">eNACH</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-8">
                {/* Stepper */}
                <div className="d-flex align-items-center mb-4">
                  {[
                    { key: "form", label: "1. Bank Details" },
                    { key: "confirm", label: "2. Confirm Mandate" },
                    { key: "otp", label: "3. Verify OTP" },
                    { key: "success", label: "4. Registered" },
                  ].map((s, i) => (
                    <React.Fragment key={s.key}>
                      <div
                        className="d-flex align-items-center"
                        style={{
                          opacity:
                            step === s.key ||
                            (step === "success")
                              ? 1
                              : 0.4,
                        }}
                      >
                        <div
                          style={{
                            width: 26,
                            height: 26,
                            borderRadius: "50%",
                            background:
                              step === s.key
                                ? "#1890ff"
                                : step === "success"
                                ? "#52c41a"
                                : "#d9d9d9",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 12,
                            fontWeight: "bold",
                            flexShrink: 0,
                          }}
                        >
                          {step === "success" ? "✓" : i + 1}
                        </div>
                        <span
                          className="ms-1"
                          style={{ fontSize: 12, whiteSpace: "nowrap" }}
                        >
                          {s.label}
                        </span>
                      </div>
                      {i < 3 && (
                        <div
                          style={{
                            flex: 1,
                            height: 2,
                            background: "#e8e8e8",
                            margin: "0 8px",
                          }}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>

                {/* Step: Form */}
                {step === "form" && (
                  <div className="card">
                    <div className="card-header">
                      <h5 className="mb-0">Bank Account Details</h5>
                    </div>
                    <div className="card-body">
                      <p className="text-muted mb-4" style={{ fontSize: 13 }}>
                        Register your bank account for automatic EMI debit on the due date.
                        This is a one-time setup via eNACH mandate.
                      </p>

                      {error && <div className="alert alert-danger">{error}</div>}

                      <form onSubmit={handleFormSubmit}>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Account Holder Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="As per bank records"
                              required
                              value={form.accountHolder}
                              onChange={(e) =>
                                setForm((f) => ({ ...f, accountHolder: e.target.value }))
                              }
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Account Type</label>
                            <select
                              className="form-select"
                              value={form.accountType}
                              onChange={(e) =>
                                setForm((f) => ({ ...f, accountType: e.target.value }))
                              }
                            >
                              <option value="SAVINGS">Savings</option>
                              <option value="CURRENT">Current</option>
                            </select>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Account Number <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Bank account number"
                              required
                              value={form.accountNumber}
                              onChange={(e) =>
                                setForm((f) => ({ ...f, accountNumber: e.target.value }))
                              }
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Confirm Account Number <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Re-enter account number"
                              required
                              value={form.confirmAccount}
                              onChange={(e) =>
                                setForm((f) => ({
                                  ...f,
                                  confirmAccount: e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              IFSC Code <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="e.g. SBIN0001234"
                              maxLength={11}
                              required
                              value={form.ifsc}
                              onChange={(e) =>
                                setForm((f) => ({
                                  ...f,
                                  ifsc: e.target.value.toUpperCase(),
                                }))
                              }
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Bank Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Your bank name"
                              value={form.bankName}
                              onChange={(e) =>
                                setForm((f) => ({ ...f, bankName: e.target.value }))
                              }
                            />
                          </div>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">
                            Preferred EMI Debit Day of Month
                          </label>
                          <select
                            className="form-select"
                            style={{ maxWidth: 200 }}
                            value={form.debitDay}
                            onChange={(e) =>
                              setForm((f) => ({ ...f, debitDay: e.target.value }))
                            }
                          >
                            {[1, 5, 10, 15, 20, 25].map((d) => (
                              <option key={d} value={d}>
                                {d}th of every month
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="d-flex gap-3 mt-3">
                          <button type="submit" className="btn btn-primary">
                            <i className="fa-solid fa-arrow-right me-2"></i>
                            Continue to Confirm
                          </button>
                          <Link
                            to="/my-marketplace-loans"
                            className="btn btn-outline-secondary"
                          >
                            Cancel
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                {/* Step: Confirm */}
                {step === "confirm" && (
                  <div className="card">
                    <div className="card-header">
                      <h5 className="mb-0">Confirm eNACH Mandate</h5>
                    </div>
                    <div className="card-body">
                      <div
                        className="p-3 mb-4"
                        style={{ background: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: 6 }}
                      >
                        <h6 className="mb-3">Mandate Details</h6>
                        <table className="table table-borderless table-sm mb-0" style={{ fontSize: 13 }}>
                          <tbody>
                            <tr>
                              <td className="text-muted" style={{ width: "40%" }}>Account Holder</td>
                              <td><strong>{form.accountHolder}</strong></td>
                            </tr>
                            <tr>
                              <td className="text-muted">Bank</td>
                              <td>{form.bankName || "—"}</td>
                            </tr>
                            <tr>
                              <td className="text-muted">Account Number</td>
                              <td>
                                {"*".repeat(Math.max(0, form.accountNumber.length - 4))}
                                {form.accountNumber.slice(-4)}
                              </td>
                            </tr>
                            <tr>
                              <td className="text-muted">IFSC</td>
                              <td>{form.ifsc}</td>
                            </tr>
                            <tr>
                              <td className="text-muted">Account Type</td>
                              <td>{form.accountType}</td>
                            </tr>
                            <tr>
                              <td className="text-muted">Debit Day</td>
                              <td>{form.debitDay}th of every month</td>
                            </tr>
                            <tr>
                              <td className="text-muted">Loan Request ID</td>
                              <td>{loanRequestId}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div
                        className="p-3 mb-4"
                        style={{ background: "#fffbe6", border: "1px solid #ffe58f", borderRadius: 6, fontSize: 12 }}
                      >
                        <strong>Important:</strong> By proceeding, you authorize OxyLoans to
                        debit your bank account for EMI amounts on the scheduled due dates via
                        NACH mandate. This authorization will remain valid for the loan tenure.
                      </div>

                      <div className="d-flex gap-3">
                        <button className="btn btn-success" onClick={sendOtp} disabled={loading}>
                          {loading ? (
                            <span className="spinner-border spinner-border-sm me-2"></span>
                          ) : (
                            <i className="fa-solid fa-check me-2"></i>
                          )}
                          Confirm & Send OTP
                        </button>
                        <button
                          className="btn btn-outline-secondary"
                          onClick={() => setStep("form")}
                        >
                          Edit Details
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Step: OTP */}
                {step === "otp" && (
                  <div className="card">
                    <div className="card-header">
                      <h5 className="mb-0">OTP Verification</h5>
                    </div>
                    <div className="card-body text-center py-5">
                      <i
                        className="fa-solid fa-mobile-screen mb-3"
                        style={{ fontSize: 48, color: "#1890ff" }}
                      ></i>
                      <p className="text-muted mb-4">
                        An OTP has been sent to your registered mobile number to authorize
                        the eNACH mandate.
                      </p>

                      <div className="row justify-content-center">
                        <div className="col-md-6">
                          <input
                            type="text"
                            className="form-control text-center mb-3"
                            placeholder="Enter 4-digit OTP"
                            maxLength={4}
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            style={{ fontSize: 24, letterSpacing: 8, fontWeight: "bold" }}
                          />

                          {error && <div className="alert alert-danger">{error}</div>}

                          <button
                            className="btn btn-success w-100"
                            onClick={verifyOtp}
                            disabled={loading || otp.length < 4}
                          >
                            {loading ? (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : (
                              <i className="fa-solid fa-shield-halved me-2"></i>
                            )}
                            Verify & Register Mandate
                          </button>

                          <button className="btn btn-link btn-sm mt-2" onClick={sendOtp}>
                            Resend OTP
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Step: Success */}
                {step === "success" && (
                  <div className="card text-center">
                    <div className="card-body py-5">
                      <div
                        style={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background: "#f6ffed",
                          border: "3px solid #52c41a",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 20px",
                        }}
                      >
                        <i
                          className="fa-solid fa-check"
                          style={{ fontSize: 36, color: "#52c41a" }}
                        ></i>
                      </div>
                      <h4 className="text-success mb-2">eNACH Mandate Registered!</h4>
                      <p className="text-muted">
                        Auto-debit mandate for{" "}
                        <strong>
                          {"*".repeat(Math.max(0, form.accountNumber.length - 4))}
                          {form.accountNumber.slice(-4)}
                        </strong>{" "}
                        has been registered successfully.
                        <br />
                        Your EMIs will be automatically debited on the{" "}
                        <strong>{form.debitDay}th</strong> of every month.
                      </p>
                      <div className="mt-4 d-flex justify-content-center gap-3 flex-wrap">
                        <button
                          className="btn btn-success"
                          onClick={() => navigate("/borrowerDashboard")}
                        >
                          <i className="fa-solid fa-house me-2"></i>
                          Go to Dashboard
                        </button>
                        <Link to="/my-marketplace-loans" className="btn btn-outline-primary">
                          <i className="fa-solid fa-list me-2"></i>
                          View My Loans
                        </Link>
                        <Link to="/borrower-emi-schedule" className="btn btn-outline-secondary">
                          <i className="fa-solid fa-calendar-check me-2"></i>
                          View EMI Schedule
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketplaceEnach;
